import React, {useState, useEffect} from 'react';

const FieldIdSelector = ({fields, nullAllowed, initialValue, onChange}) => {

  const [value, setValue] = useState(initialValue);
  const [_fields, setFields] = useState(fields);

  useEffect(() => onChange(value), [value]);
  useEffect(() => setFields(fields), [fields]);
  useEffect(() => {
    if (_fields && value && !_fields.find(f => f.id === value)) {
      setValue(null);
    }
  }, [_fields]);

  return <select className="form-select"
                 value={value || ''}
                 onChange={e => setValue(e.target.value)}>
    {nullAllowed && <option value={null}/>}
    {_fields.map(field => <option key={field.id} value={field.id}>{field.name}</option>)}
  </select>;
};

const FieldMapping = ({label, sourceFields, initialModel, onChange}) => {

  const [model, setModel] = useState(initialModel || {});
  const [_sourceFields, setSourceFields] = useState(sourceFields);

  useEffect(() => onChange(model), [model]);
  useEffect(() => setSourceFields(sourceFields), [sourceFields]);

  return <>
    {label && <div>{label}</div>}
    <FieldIdSelector fields={_sourceFields}
                     nullAllowed={true}
                     initialValue={(model || {}).fieldId}
                     onChange={value => setModel(value ? {type: 'field', fieldId: value} : null)}/>
  </>;
};
export {FieldMapping};

const FieldList = ({sourceFields, initialModel, onChange}) => {

  const [model, setModel] = useState(initialModel || []);
  const [_sourceFields, setSourceFields] = useState(sourceFields);

  useEffect(() => onChange(model), [model]);
  useEffect(() => setSourceFields(sourceFields), [sourceFields]);

  const availableFields = () => _sourceFields.filter(f => !model.includes(f.id));

  return <ul className="list-group">
    {model.map((fieldId, i) => <li key={fieldId} className="list-group-item">
      <div className="row align-items-center">
        <div className="col">
          <FieldIdSelector fields={_sourceFields.filter(f => f.id === fieldId || !model.includes(f.id))}
                           nullAllowed={false}
                           initialValue={fieldId}
                           onChange={value => setModel(m => m.map((id, j) => j === i ? value : id))}/>
        </div>
        <div className="col-auto">
          <button type="button"
                  className="btn btn-sm btn-danger"
                  onClick={() => setModel(model.filter((_, j) => j !== i))}>
            <span className="material-icons align-middle">&#xE872;</span>
          </button>
        </div>
      </div>
    </li>)}
    <li className="list-group-item">
      <div className="row">
        <div className="col">
        </div>
        <div className="col-auto">
          <button type="button"
                  className="btn btn-sm btn-success"
                  onClick={() => setModel([...model, availableFields()[0].id])}
                  disabled={availableFields().length === 0}>
            {model.length > 0 ?
              <span className="material-icons align-middle">&#xE145;</span> :
              <span className="px-3">Add field</span>
            }
          </button>
        </div>
      </div>
    </li>
  </ul>;
};

const FieldListMapping = ({label, sourceFields, initialModel, onChange}) => {

  const [model, setModel] = useState({...(initialModel || {}), type: 'field-list'});
  const [_sourceFields, setSourceFields] = useState(sourceFields);

  useEffect(
    () => onChange(!model.fieldIds || model.fieldIds.length === 0 ? null : model),
    [model]
  );
  useEffect(() => setSourceFields(sourceFields), [sourceFields]);

  return <>
    {label && <div>{label}</div>}
    <div className="ms-md-5">
      <FieldList sourceFields={_sourceFields}
                 initialModel={model.fieldIds}
                 onChange={value => setModel({...model, fieldIds: value})}/>
    </div>
  </>;
};
export {FieldListMapping};

const IntegrationMappings = ({sourceFields, targetFields, initialModel, onChange}) => {

  const [model, setModel] = useState(initialModel || {});
  const [_sourceFields, setSourceFields] = useState(sourceFields);

  useEffect(() => onChange(model ?
    Object.entries(model).reduce((result, [k, v]) => {
      if (v) {
        result[k] = v;
      }
      return result;
    }, {}) :
    null
  ), [model]);
  useEffect(() => setSourceFields(sourceFields), [sourceFields]);

  const updateModel = (fieldName, value) => setModel(m => {
    const newModel = {...m};
    newModel[fieldName] = value;
    return newModel;
  });

  return <>
    {targetFields.map(targetField => <div key={targetField.key} className="mb-3">
      {targetField.type === 'field-list' ?
        <FieldListMapping label={targetField.label}
                          sourceFields={_sourceFields}
                          initialModel={model[targetField.key] || {}}
                          onChange={v => updateModel(targetField.key, v)}/> :
        <FieldMapping label={targetField.label}
                      sourceFields={targetField.sourceFieldFilter ?
                        _sourceFields.filter(f => targetField.sourceFieldFilter(f)) :
                        _sourceFields
                      }
                      initialModel={model[targetField.key] || {}}
                      onChange={v => updateModel(targetField.key, v)}/>
      }
    </div>)}
  </>
};

export default IntegrationMappings;
